{
  "title": "Administradores",
  "subtitle": "Quién entra al Admin de tu empresa y hasta dónde llega.",
  "actions": {
    "new": "Nuevo administrador",
    "edit": "Editar",
    "disable": "Deshabilitar",
    "enable": "Habilitar",
    "regenerateLink": "Regenerar enlace"
  },
  "filters": {
    "role": "Rol",
    "roleAll": "Todos los roles",
    "status": "Estado",
    "statusAll": "Todos los estados"
  },
  "fields": {
    "name": "Nombre",
    "email": "Correo",
    "role": "Rol",
    "scope": "Alcance",
    "status": "Estado"
  },
  "roles": {
    "SUPER_ADMIN": "Fermin (soporte)",
    "COMPANY_ADMIN": "Administrador",
    "SITE_MANAGER": "Encargado de sede",
    "VIEWER": "Solo lectura"
  },
  "status": {
    "ENABLED": "Habilitado",
    "DISABLED": "Deshabilitado"
  },
  "scope": {
    "all": "Toda la empresa",
    "none": "Sin sedes"
  },
  "table": {
    "caption": "Administradores de la empresa",
    "actions": "Acciones",
    "noPassword": "Sin contraseña",
    "noActiveSites": "Sin sedes activas: hoy no ve datos operativos."
  },
  "empty": {
    "title": "Todavía no hay más administradores",
    "description": "Crea un encargado de sede para delegar la operación de una sede."
  },
  "form": {
    "createTitle": "Nuevo administrador",
    "editTitle": "Editar administrador",
    "description": "Recibirás un enlace de configuración de contraseña para entregárselo. El enlace se muestra una sola vez y vence en 72 horas.",
    "scopeLabel": "Sedes del alcance",
    "scopeHelp": "Elige al menos una sede activa. El encargado solo verá esas sedes.",
    "scopeEmpty": "No hay sedes activas. Crea una sede antes de asignar un encargado.",
    "emailLocked": "El correo no se puede cambiar.",
    "errors": {
      "name": "Escribe un nombre de 1 a 120 caracteres.",
      "email": "Escribe un correo válido.",
      "emailTaken": "Ya existe un administrador con ese correo.",
      "scope": "Elige al menos una sede activa de tu empresa."
    }
  },
  "confirm": {
    "disableTitle": "¿Deshabilitar a este administrador?",
    "disableDescription": "{name} dejará de poder entrar y sus sesiones se cerrarán de inmediato.",
    "enableTitle": "¿Habilitar a este administrador?",
    "enableDescription": "{name} volverá a poder entrar con su contraseña.",
    "note": "Puedes revertirlo cuando quieras. El cambio queda en la auditoría."
  },
  "toast": {
    "created": "Administrador creado.",
    "updated": "Administrador actualizado.",
    "disabled": "Administrador deshabilitado.",
    "enabled": "Administrador habilitado.",
    "linkRegenerated": "Enlace regenerado.",
    "lastAdmin": "No puedes deshabilitar al último administrador habilitado de la empresa.",
    "hasPassword": "Este administrador ya definió su contraseña."
  }
}
